import { SimpleCrudController } from './simpleCrud.controller';

const angular = require('angular');

class Tr extends EventTarget {
  public result: Object;
}
export default angular
  .module('directives.simpleCrudComponent', [])

  .directive('fileread', () => {
    return {
      scope: {
        fileread: '='
      },
      link: (scope, element, attributes) => {
        // console.log('attributes', attributes);
        if (attributes.type && attributes.type === 'file') {
          element.bind('change', changeEvent => {
            var reader = new FileReader();
            reader.onload = loadEvent => {
              scope.$apply(() => {
                scope.fileread = (<Tr>loadEvent.target).result;
                // or all selected files:
                // scope.fileread = changeEvent.target.files;
              });
            };
            reader.readAsDataURL(changeEvent.target.files[0]);
          });
        }
      }
    };
  })
  .directive('validFile', function() {
    return {
      require: 'ngModel',
      link: function(scope, el, attrs, ngModel) {
        ngModel.$render = function() {
          ngModel.$setViewValue(el.val());
        };

        el.bind('change', function() {
          scope.$apply(function() {
            ngModel.$render();
          });
        });
      }
    };
  })
  .component('simpleCrud', {
    template: require('./index.pug'),
    controller: SimpleCrudController,
    controllerAs: 'sCrud',
    bindings: {
      service: '=',
      translations: '=',
      fields: '=?'
    },
    bindToController: true
  }).name;



// WEBPACK FOOTER //
// ./client/components/simpleCrud/index.ts